import * as React from "react";

interface RefProps {
    color?: string;
    size?: number;
    fill?: string
}

const ShapeIcon = React.forwardRef<SVGSVGElement, RefProps>(({ color = 'currentColor', size = 24, fill = 'black', ...rest }, ref) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather" ref={ref} {...ref}>
            <circle cx="16" cy="9" r="7"></circle>
            <rect rx="2" ry="2" width="14" height="14" x="5" y="8" className="fill"></rect>
        </svg>

    );
});

export default ShapeIcon;
